import React from "react";
import { Editor } from "@tiptap/react";

import { ChangeEvent } from "react";
import { ColorIcon } from "../../tiptap-icons/color-icon";
import { MarkButton } from "../mark-button";
import { Button } from "@components/SAPPEditor/tiptap-ui-primitive/button";

const classes = {
  color: {
    position: "absolute" as const,
    top: 20,
    left: 0,
    width: 0,
    height: 0,
    opacity: 0,
    WebkitAppearance: "none" as const,
    MozAppearance: "none" as const,
    appearance: "none" as const,
    pointerEvents: 'none' as const,
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    "&::WebkitColorSwatch": {
      borderRadius: 4,
      border: "none"
    },
    "&::MozColorSwatch": {
      borderRadius: 4,
      border: "none"
    }
  }
};
type Props = {
  editor: Editor;
};
const ColorPicker = ({ editor }: Props) => {
  const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
    editor.chain().focus().setColor(event.target.value).run();
  };
  const isActive = !!editor.getAttributes("textStyle").color;
  return (
    <div style={{ position: 'relative' }}>
        <Button
          disabled={false}
          data-style="ghost"
          data-active-state={isActive ? 'on' : 'off'}
          data-disabled={false}
          data-size="large"
          type="button"
          role="button"
          onClick={() => document.getElementById('color-picker')?.click()}
        >
          <ColorIcon className="tiptap-button-icon" style={{
            color: editor.getAttributes("textStyle").color
          }} />
        </Button>

      <input
        id="color-picker"
        type="color"
        onInput={handleInput}
        value={editor.getAttributes("textStyle").color}
        style={classes.color}
      />
    </div>
  );
};

export default ColorPicker;
